<template>
<div class="form" id="doceditorID">
<a-card size="small" :title="pageInfo.title" style="min-width:1150px;">
    <template slot="extra" >
        <a-button type="primary" @click="handleOk" :loading="confirmLoading" style="margin-right:20px;">
                保存
            </a-button>
        <a-button icon="api"  type="primary"  @click="handleImportYapi" style="margin-right:20px;" v-if="pageInfo.type == '1'" >导入Yapi文档</a-button>
        <a-button type="primary" style="margin-right:20px;" @click="handleUpdate">更新</a-button>
        <a-button type="normal" @click="handleBack">返回</a-button>
        <!-- yapi生成器 -->
        <yapiReader ref="yapiID" @handleSelected="handleYapiSelected"></yapiReader>
    </template>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  >

            <a-form-model-item  label="菜单" v-if="pageInfo.type != '2' && pageInfo.type != '3'">
                <b style="color:#186fac;">{{ pTitle + '/' + cTitle }}</b>
            </a-form-model-item>

            <a-form-model-item ref="type" label="类型" prop="type">
                <b>{{ typeName[pageInfo.type] }}</b>
            </a-form-model-item>

            <a-form-model-item ref="version" label="版本" prop="version" v-if="pageInfo.type == '1'">
                <a-input
                    v-model="record.version" placeholder="输入版本号" @blur="() => {$refs.version.onFieldBlur();}"
                />
            </a-form-model-item>

            <a-form-model-item ref="tags" label="标签" prop="tags"  v-if="pageInfo.type == '1'">
                <a-input
                    v-model="record.tags" placeholder="选择标签" @blur="() => {$refs.tags.onFieldBlur();}"
                />
            </a-form-model-item>
            
            <!-- <a-form-model-item ref="name" label="类名" prop="name" v-if="pageInfo.type == '1'">
                <a-input
                    v-model="record.name" placeholder="菜单分类名称"  @blur="() => {$refs.name.onFieldBlur();}"
                />
            </a-form-model-item> -->

            <!-- <a-form-model-item ref="status" label="状态" prop="status" v-if="pageInfo.type != '2'">
                <a-radio-group  v-model="record.status">
                    <a-radio value="1">
                    已发表
                    </a-radio>
                    <a-radio value="0">
                    未发表
                    </a-radio>
                </a-radio-group>
            </a-form-model-item> -->
            
            <a-form-model-item ref="title" label="标题" prop="title">
                <a-input
                    style="width:486px;"
                    v-model="record.title" placeholder="输入标题"  @blur="() => {$refs.title.onFieldBlur();}"
                />
            </a-form-model-item>

            <a-form-model-item ref="desc" label="描述" prop="desc" v-if="pageInfo.type == '2'">
                <a-input
                    v-model="record.desc" placeholder="输入描述"  @blur="() => {$refs.desc.onFieldBlur();}"
                />
            </a-form-model-item>
        </a-form-model>

        

        <div class="ueEditorBox">
            <div v-if="pageInfo.type == '1'">
                <p>描述：</p>
                <QEditor v-model="record.desc" :height="300"></QEditor>
                <errorEditor :errorinfos="record.errorinfos" @handleErrorDataChange="handleErrorDataChange"></errorEditor>
                <mappingEditor :requestMapping="record.requestmapping" @handleMappingDataChange="handleMappingDataChange"></mappingEditor>
                <Apiview ref="apiViewID" :key="vid" ></Apiview>
            </div>
            <QEditor :height="900" v-model="record.body" v-else></QEditor>
        </div>
        

        <div class="btns">
            <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                保存
            </a-button>
            <a-button style="margin-left: 10px;" @click="handleCancel">
                取消
            </a-button>
        </div>
 </a-card>
</div>

</template>
<script>
import QEditor from '@/components/QEditor/QEditor'
import Apiview from './comp/apiview'
// adddoc|addapi|editdoc|editapi|addtemp|edittemp
import yapiReader from './comp/yapireader'
import errorEditor from './comp/errcode'
import mappingEditor from './comp/paramMapping'

const actionName = {
    'adddoc':{
        action:'add',
        title:'新增文档',
        type:'0'
    },
    'editdoc':{
        action:'edit',
        title:'编辑文档',
        type:'0'
    },
    'addapi':{
        action:'add',
        title:'新增API',
        type:'1'
    },
    'editapi':{
        action:'edit',
        title:'编辑API',
        type:'1'
    },
    'addtemp':{
        action:'add',
        title:'新增模板',
        type:'2'
    },
    'edittemp':{
        action:'edit',
        title:'编辑模板',
        type:'2'
    },
    'addnotice':{
        action:'add',
        title:'新增公告',
        type:'3'
    },
    'editnotice':{
        action:'edit',
        title:'编辑公告',
        type:'3'
    },
};

export default {
    data() {
        return {
            errorData:[],
            mappingData:[],
            vid:+new Date(),
            typeName : {
                '0':'普通文档',
                '1':'API文档',
                '2':'模板文档',
                '3':'公告文档'
            },
            pageInfo:{
                action:'add',
                title:'新增API',
                type:'1'
            },
            rules: {
                title: [
                    { required: true, message: ' 请输入文档标题 ', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'inline',
            record:{
                id:'',
                version:'',
                path:'',
                tags:'',
                menucode:'',
                name:'',
                title:'',
                desc:'',
                status:'0',
                body:'',
                createtime:'',
                createuser:'',
                updatetime:'',
                updatetuser:''
            },
            pTitle:'',
            cTitle:'',

        };
    },
    components:{
        QEditor,
        yapiReader,
        Apiview,
        errorEditor,
        mappingEditor
    },
    methods: {
        handleErrorDataChange(errData){
            this.errorData = errData;
        },

        handleMappingDataChange(mappingData){
            this.mappingData = mappingData;
        },

        handleUpdate(){
            let yapiID  = '1437';
            let that = this;
            let dataSource = [];
             
            this.$store.dispatch({
                type: "open/yapilist",
                params: {
                    projectcode:yapiID,
                    urlparams:false,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let target = res.data.data.data;
                    if(typeof(target) == 'string'){
                        target = JSON.parse(target);
                    }
                    if(target.length > 0){
                        target.forEach(element => {
                            dataSource = dataSource.concat(element.list)
                        });
                    }

                    let result = dataSource.filter(function(n){
                        return that.record.path == n.path
                    });
                    if(result.length > 0){
                        that.handleYapiSelected(result[0]._id)
                        that.message.success('文档更新，请点击保存')
                    }
                    else{
                        that.message.error('未找到yapi文档')

                    }
                }
                else{
                    that.message.error('未找到yapi文档')
                }
            }).catch(() => {
            });
        },
        
        //选择接口文档
        handleYapiSelected(yapiID){
            this.vid = +new Date();
            //获取yapi详情
            this.$store.dispatch({
                type: "open/yapidesc",
                params: {
                    code:yapiID,
                    urlparams:false,
                },
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let temData = res.data.data.data;
                    //yapi数据固定不可编辑
                    this.record.body = JSON.stringify(temData);
                    this.initApiData(1);
                }
                else{
                    this.message.error('未查询到yapi信息')
                }
            });
        },

        initApiData(flag){
            if(this.record.errorinfos){
                this.errorInfoList = JSON.parse(this.record.errorinfos)
            }
            else{
                this.errorInfoList = []
            }
            if(this.record.requestmapping){
                this.requestmappingList = JSON.parse(this.record.requestmapping)
            }
            else{
                this.requestmappingList = []
            }
            let temData = this.record.body;
            if(!temData){
                return
            }
            temData = JSON.parse(temData)
            if(flag == 1){
                this.record.title = temData.title;
                this.record.path = temData.path;
            }
            
            if(temData.req_query){
                let tempData = temData.req_query;

                if(typeof(temData.req_query) == 'string'){
                    tempData = JSON.parse(temData.req_query)
                }
                let target = tempData.filter((item) => {
                    return item.name == 'appkey';
                });
                if(tempData.length > 0 && target.length == 0){
                    let appcodeData = [{
                        desc: "公钥",   
                        example: "",
                        name: "appkey",
                        required: "1",
                    }]
                    temData.req_query = JSON.stringify(appcodeData.concat(tempData))
                }
            }
            if(temData.req_body_other){
                let data = temData.req_body_other;
                if(typeof(temData.req_body_other) == 'string'){
                    data = JSON.parse(temData.req_body_other);
                }
                //统一加appkey
                if(data.type == 'object'){
                    if(!data.properties.appcode && JSON.stringify(data.properties) != '{}'){
                        let tempObj = {};
                        tempObj.appkey = {
                            "type": "string",
                            "description": "公钥"
                        };
                        for (const key in data.properties) {
                            if (data.properties.hasOwnProperty(key)) {
                                const element = data.properties[key];
                                tempObj[key] = element
                            }
                        }
                        data.properties = tempObj;
                        if(!data.required){
                            data.required = ['appkey']
                        }
                        else{
                            data.required.push('appkey')
                        }
                        temData.req_body_other = JSON.stringify(data)
                    }
                    else{
                        temData.req_body_other = ''
                    }
                }
            }
            this.record.body = JSON.stringify(temData)
            
            //导入的时候 desc 和加载的时候的desc
            if(temData.desc){
                this.record.desc = temData.desc;
            }
            this.$refs.apiViewID.renderYapiHtml(temData);
        },
        
        handleOk() {
            
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.record.errorinfos = JSON.stringify(that.errorData);
                    that.record.requestmapping = JSON.stringify(that.mappingData);
                    that.confirmLoading = false;
                    if(that.pageInfo.action == 'edit'){
                        that.$store
                            .dispatch({
                                type: "open/updatedoc",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(that.pageInfo.action == 'add'){
                        that.record.id = '';
                        this.record.type = this.pageInfo.type;
                        //新增
                        that.$store
                            .dispatch({
                                type: "open/adddoc",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        triggerValidate(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(valid)
                }
            })
            this.confirmLoading = false;

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },

        resetForm() {
            this.errorInfoList = [];
            this.requestmappingList = [];
            this.$refs.ruleForm.resetFields();
        },

        getDetail(){
            let that = this;
            let params = {
                menucode:that.record.menucode,
                urlparams:false
            }
            if(that.record.id){
                params = {
                    id:that.record.id,
                    urlparams:false
                }
            }
            that.$store.dispatch({
                type: "open/selectOnedoc",
                params: params,
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    that.record.type = that.pageInfo.type;
                    //如果是API，初始化接口数据
                    if(that.record.type == '1'){

                        that.initApiData();
                    }
                }
            });
        },

        //yapi导入相关
        handleImportYapi(){
            this.$refs.yapiID.showModal();
        },

        handleBack(){
            this.$router.back(-1);
        }
    },

    mounted(){
        const { params,query } = this.$route;
        this.pageInfo = actionName[params.action];
        let lastItem = localStorage.getItem('docManagerSelectItem');
        //模板文档
        if(this.pageInfo.type == '2'){
            this.record.menucode = 'templete'
        }
        if(this.pageInfo.type == '3'){
            this.record.menucode = 'notice'
        }
        else{
            //获取当前选中的菜单
            if(lastItem){
                lastItem = JSON.parse(lastItem);
                this.record.menucode = lastItem.cMenucode;
                this.pTitle = lastItem.pTitle;
                this.cTitle = lastItem.cTitle;
            }
            if(query.id){
                this.record.id = query.id
            }
        }
        // 初始化
        if (this.pageInfo.action == "add") {
            //新建重置表单
            this.resetForm();
        }
        else{
            //编辑获取详情
            this.getDetail()
        }

    }
};
</script>

<style scoped>

.ant-form-inline .ant-form-item{
    margin-right:40px;
}

.btns{
    margin: 20px 0;
    display:flex;
    justify-content: center;
}

.lineItem{
    width: 100%;
}

.ueEditorBox{
    margin: 20px 0;
}
</style>

<style>
#doceditorID .ant-form-item-with-help{
    margin-bottom:0px;
}
</style>
